/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { pxToEm } from '@insticator/insticator-ui';



/* ++++++++++ --------------- ARTICLE SENTIMENT V2 - ANALYTICS PAGE : STYLES --------------- ++++++++++ */
export default {
    articlesentimentv2analyticspage: {
    }
};
